import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
interface FeaturePointRlt2Props {
  children: React.ReactNode;
}
const FeaturePointRlt2 = ({
  children
}: FeaturePointRlt2Props) => {
  return <div className="flex items-start" data-id="element-16955" data-mp="6bd7l53r64yp">
      <CheckCircleIcon className="h-4 w-4 text-gray-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-16956" data-mp="6a20owf0gh3d" />
      <span className="text-sm text-gray-700" data-id="element-16957" data-mp="1bifiy88r9c2">{children}</span>
    </div>;
};
export default FeaturePointRlt2;